import React from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

import ChangeCountryCurrency from "../components/home/more/ChangeCountryCurrency";
import ContactUs from "../components/home/more/ContactUs";
import DeliveryTime from "../components/home/more/DeliveryTime";
import DutiesTaxes from "../components/home/more/DutiesTaxes";
import InternationalTransactionFees from "../components/home/more/InternationalTransactionFees";
import PaymentMethods from "../components/home/more/PaymentMethods";
import PriceCurrencies from "../components/home/more/PriceCurrencies";
import Refund from "../components/home/more/Refund";
import Returns from "../components/home/more/Returns";
import ShippingCost from "../components/home/more/ShippingCost";
import ShippingMethods from "../components/home/more/ShippingMethods";
import Tracking from "../components/home/more/Tracking";

import Authentification from "../components/home/worldOfWonley/Authentification";
import Club from "../components/home/worldOfWonley/Club";
import Episodes from "../components/home/worldOfWonley/Episodes";
import FollowUs from "../components/home/worldOfWonley/FollowUs";
import Meaning from "../components/home/worldOfWonley/Meaning";
import Membership from "../components/home/worldOfWonley/Membership";
import Mission from "../components/home/worldOfWonley/Mission";
import OneOfOneLuxury from "../components/home/worldOfWonley/OneOfOneLuxury";
import Philanthropy from "../components/home/worldOfWonley/Philanthropy";
import Products from "../components/home/worldOfWonley/Products";
import PurchasingProduct from "../components/home/worldOfWonley/PurchasingProduct";
import Support from "../components/home/worldOfWonley/Support";
import Fundraiser from "./home/worldOfWonley/Fundraiser";
import Gifts from "./home/worldOfWonley/Gifts";

import Body from "../components/home/worldOfWonley/Episodes/SubEpisodes/Body";
import Joy from "../components/home/worldOfWonley/Episodes/SubEpisodes/Joy";
import Knowledge from "../components/home/worldOfWonley/Episodes/SubEpisodes/Knowledge";
import Mind from "../components/home/worldOfWonley/Episodes/SubEpisodes/Mind";
import ViewEpisodes from "../components/home/worldOfWonley/Episodes/ViewEpisodes";

import Measure from "./home/products/Measure";
import ProductDetails from "./home/products/ProductDetails";
import ProductDimensions from "./home/products/ProductDimensions";
import ProductPrice from "./home/products/ProductPrice";
import ProductQuestions from "./home/products/ProductQuestions";
import ProductRelated from "./home/products/ProductRelated";
import ProductSizeGuide from "./home/products/ProductSizeGuide";
import ProductVideo from "./home/products/ProductVideo";
import ShopProduct from "./home/products/ShopProduct";
import SizePicker from "./home/products/SizePicker";
import Material from "./home/products/product-details/Material";
import ProductInfo from "./home/products/product-details/ProductInfo";
import ProductRelatedVideo from "./home/products/product-details/ProductRelatedVideo";
import Purchase from "./home/products/product-details/Purchase";
import SuccessPaid from "./home/products/product-details/SuccessPaid";

// Routes for content changes !!!
import PrivacyPolicy from "./home/more/PrivacyPolicy";
import TermsAndConditions from "./home/more/TermsAndConditions";

// admin
import AdEditSizeGuide from "./admin/AdEditSizeGuide";
import AdPicture from "./admin/AdPicture";
import AdProductImage from "./admin/AdProductImage";
import AdProduct from "./admin/AdProducts";
import AdSizeGuideImage from "./admin/AdSizeGuideImage";
import AdType from "./admin/AdType";
import AdTypeVideo from "./admin/AdTypeVideo";
import AdVideo from "./admin/AdVideo";
import AdminHome from "./admin/AdminHome";
import EditSize from "./admin/EditSize";
import OrderDetails from "./admin/OrderDetails";
import Orders from "./admin/Orders";
import Shippings from "./admin/Shippings";
import ViewSizeGuides from "./admin/SizeGuides";
import Sizes from "./admin/Sizes";
import Types from "./admin/Types";
import ViewDimensions from "./admin/ViewDimensions";
import ViewProduct from "./admin/ViewProduct";
import ViewProducts from "./admin/ViewProducts";
import ViewProductsAuth from "./admin/ViewProductsAuth";

// size finder
import ViewMembers from "./admin/ViewMembers";
import AdOption from "./admin/sizeFinder/AdOption";
import AdOptionImage from "./admin/sizeFinder/AdOptionImage";
import AdStep from "./admin/sizeFinder/AdStep";
import AnswerDetails from "./admin/sizeFinder/AnswerDetails";
import ViewAnswers from "./admin/sizeFinder/ViewAnswers";
import ViewOptions from "./admin/sizeFinder/ViewOptions";
import ViewSizeFinders from "./admin/sizeFinder/ViewSizeFinders";
import ViewSteps from "./admin/sizeFinder/ViewSteps";

import TwoBoutiques from "./home/Boutique/TwoBoutiques";
import Taxes from "./home/more/Taxes";
import MeaningOfDesign from "./home/products/MeaningOfDesign";
import Lyrics from "./home/worldOfWonley/Mission/Lyrics";
import Music from "./home/worldOfWonley/Mission/Music";
import VideoPage from "./home/worldOfWonley/Mission/VideoPage";
import Written from "./home/worldOfWonley/Mission/Written";

// home page
import Admin from "./admin/Admin";
import Accessibility from "./home/Accessibility";
import Authentication from "./home/Authentication";
import ShowingCard from "./home/Authentication/ShowingCard";
import Transfer from "./home/Authentication/Transfer";
import TransferFinish from "./home/Authentication/TransferFinish";
import Boutique from "./home/Boutique";
import ForgotPwd from "./home/ForgotPwd";
import Home from "./home/Home";
import Men from "./home/Men";
import More from "./home/More";
import ProductCare from "./home/ProductCare";
import HomeProducts from "./home/Products";
import Women from "./home/Women";
import WorldOfWonley from "./home/WorldOfWonwonleywon";

// All videos - static videos pages
import AllVideos from "./home/AllVideos";
import Collection1BagVideo from "./home/AllVideos/collection1BagVideo";
import MeaningOfWonwonleywonName from "./home/AllVideos/meaningOfWonwonleywonName";
import MissionVideo from "./home/AllVideos/missionVideo";
import MusicVideo from "./home/AllVideos/musicVideo";
import OneOfOneLuxuryVideo from "./home/AllVideos/oneOfOneLuxuryVideo";
import CollectionsVideo from "./home/CollectionsVideo";

import AboutUs from "./home/AllVideos/aboutUs";
import Collection10Video from "./home/AllVideos/collection10Video";
import Collection1112Video from "./home/AllVideos/collection1112Video";
import Collection13Video from "./home/AllVideos/collection13Video";
import Collection14Video from "./home/AllVideos/collection14Video";
import NowSellingOnWhatnot from "./home/AllVideos/NowSellingOnWhatnot";
import Collection15Video from "./home/AllVideos/collection15Video";
import Collection16Video from "./home/AllVideos/collection16Video";
import Collection17Video from "./home/AllVideos/collection17Video";
import Collection18Video from "./home/AllVideos/collection18Video";
import Collection2Video from "./home/AllVideos/collection2Video";
import Collection3Video from "./home/AllVideos/collection3Video";
import Collection4Video from "./home/AllVideos/collection4Video";
import Collection5Video from "./home/AllVideos/collection5Video";
import Collection6Video from "./home/AllVideos/collection6Video";
import Collection7Video from "./home/AllVideos/collection7Video";
import Collection8Video from "./home/AllVideos/collection8Video";
import Collection9Video from "./home/AllVideos/collection9Video";
import FashionShow from "./home/AllVideos/fashionShow";
import HowToChangeColors from "./home/AllVideos/howToChangeColors";
import HowToShop from "./home/AllVideos/howToShop";
import SingleProductsList from "./home/products/SingleProductsList";
import NotFound from "./main/NotFound";
import TheWonleys from "./home/TheWonleys";
import AddContent from "./admin/AddContent";

const CreateRoutes = ({ username }) => {
  const user = sessionStorage.getItem("user");
  return (
    <Routes>
      {/* home page */}
      <Route path="/home" element={<Home />} />
      <Route path="/world" element={<WorldOfWonley />} />
      <Route path="/products" element={<HomeProducts />} />
      <Route path="/women/*" element={<Women />} />
      <Route path="/men/*" element={<Men />} />
      <Route path="/more" element={<More />} />
      <Route path="/boutique" element={<Boutique />} />
      <Route path="/authenticity" element={<Authentication />} />
      <Route path="/authenticity/showingcard" element={<ShowingCard />} />
      <Route path="/authenticity/transfer" element={<Transfer />} />
      <Route path="/authenticity/finish" element={<TransferFinish />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/care/:id" element={<ProductCare />} />
      <Route path="/forgot-pwd" element={<ForgotPwd />} />
      <Route path="/accessibility" element={<Accessibility />} />

      {/* more... page */}
      <Route path="/more/contact_us" element={<ContactUs />} />
      <Route
        path="/more/changecountrycurrency"
        element={<ChangeCountryCurrency />}
      />
      <Route path="/more/shipping_methods" element={<ShippingMethods />} />
      <Route path="/more/shipping_cost" element={<ShippingCost />} />
      <Route path="/more/delivery_time" element={<DeliveryTime />} />
      <Route path="/more/payment_methods" element={<PaymentMethods />} />
      <Route path="/more/duties" element={<DutiesTaxes />} />
      <Route path="/more/prices_currencies" element={<PriceCurrencies />} />
      <Route
        path="/more/int_transaction_fees"
        element={<InternationalTransactionFees />}
      />
      <Route path="/add-content" element={<AddContent />} />
      <Route path="/more/returns" element={<Returns />} />
      <Route path="/more/refund" element={<Refund />} />
      <Route path="/more/tracking" element={<Tracking />} />
      <Route path="/more/taxes" element={<Taxes />} />
      {/* end */}

      {/* world of wonwonleywon page */}
      <Route path="/world/authentification" element={<Authentification />} />
      <Route path="/world/club" element={<Club />} />
      <Route path="/world/episodes" element={<Episodes />} />
      <Route path="/world/followus" element={<FollowUs />} />
      <Route path="/world/meaning" element={<Meaning />} />
      <Route path="/world/membership" element={<Membership />} />
      <Route path="/world/mission" element={<Mission />} />
      <Route path="/world/oneofoneluxury" element={<OneOfOneLuxury />} />
      <Route path="/world/philanthropy" element={<Philanthropy />} />
      <Route path="/world/products" element={<Products />} />
      <Route path="/world/purchasingproduct" element={<PurchasingProduct />} />
      <Route path="/world/support" element={<Support />} />
      <Route path="/world/gifts" element={<Gifts />} />
      <Route path="/world/fundraiser" element={<Fundraiser />} />
      {/* end */}

      <Route path="/world/mission/music" element={<Music />} />
      <Route path="/world/mission/video" element={<VideoPage />} />
      <Route path="/world/mission/written" element={<Written />} />
      <Route path="/world/mission/lyrics" element={<Lyrics />} />
      <Route path="/collection-video/:id" element={<CollectionsVideo />} />
      {/* all videos page */}
      <Route path="/allvideos" element={<AllVideos />} />
      <Route path="/allvideos/one-of-one" element={<OneOfOneLuxuryVideo />} />
      <Route path="/allvideos/mission-video" element={<MissionVideo />} />
      <Route
        path="/allvideos/meaning-video"
        element={<MeaningOfWonwonleywonName />}
      />
      <Route path="/allvideos/music-video" element={<MusicVideo />} />
      <Route
        path="/allvideos/colection-bag"
        element={<Collection1BagVideo />}
      />
      <Route path="/allvideos/collection-2" element={<Collection2Video />} />
      <Route path="/allvideos/collection-3" element={<Collection3Video />} />
      <Route path="/allvideos/collection-4" element={<Collection4Video />} />
      <Route path="/allvideos/collection-5" element={<Collection5Video />} />
      <Route path="/allvideos/collection-18" element={<Collection18Video />} />
      <Route
        path="/allvideos/now-selling-on-whatnot"
        element={<NowSellingOnWhatnot />}
      />
      <Route path="/allvideos/collection-6" element={<Collection6Video />} />
      <Route path="/allvideos/collection-7" element={<Collection7Video />} />
      <Route path="/allvideos/collection-8" element={<Collection8Video />} />
      <Route path="/allvideos/collection-9" element={<Collection9Video />} />
      <Route path="/allvideos/collection-10" element={<Collection10Video />} />
      <Route
        path="/allvideos/collection-1112"
        element={<Collection1112Video />}
      />
      <Route path="/allvideos/collection-13" element={<Collection13Video />} />
      <Route path="/allvideos/collection-14" element={<Collection14Video />} />
      <Route path="/allvideos/collection-15" element={<Collection15Video />} />
      <Route path="/allvideos/collection-16" element={<Collection16Video />} />
      <Route path="/allvideos/collection-17" element={<Collection17Video />} />
      <Route path="/allvideos/collection-18" element={<Collection18Video />} />

      <Route path="/allvideos/fashion-show" element={<FashionShow />} />

      <Route path="/allvideos/about-us" element={<AboutUs />} />
      <Route path="/allvideos/how-to-shop" element={<HowToShop />} />
      <Route path="/allvideos/how-to-colors" element={<HowToChangeColors />} />
      {/* episodes page */}
      <Route path="/world/episodes/viewepisodes/" element={<ViewEpisodes />} />
      <Route path="/world/episodes/viewepisodes/body/" element={<Body />} />
      <Route path="/world/episodes/viewepisodes/joy/" element={<Joy />} />
      <Route
        path="/world/episodes/viewepisodes/knowledge/"
        element={<Knowledge />}
      />
      <Route path="/world/episodes/viewepisodes/mind/" element={<Mind />} />
      {/* end */}
      <Route path="/boutique/twoboutiques" element={<TwoBoutiques />} />
      <Route path="/the-wonleys" element={<TheWonleys />} />

      {/* all videos page */}

      {/* end */}

      {/* product page */}
      <Route path="/products/productrelated" element={<ProductRelated />} />
      <Route path="/products/meaning-of-design" element={<MeaningOfDesign />} />
      <Route path="/products/productvideo" element={<ProductVideo />} />
      <Route path="/products/productsizeguide" element={<ProductSizeGuide />} />
      <Route path="/products/productprice" element={<ProductPrice />} />
      <Route path="/products/shopproduct" element={<ShopProduct />} />
      <Route path="/products/productdetails" element={<ProductDetails />} />
      <Route path="/products/material" element={<Material />} />
      <Route path="/products/productinfo" element={<ProductInfo />} />
      <Route path="/products/purchase" element={<Purchase />} />
      <Route path="/products/success" element={<SuccessPaid />} />
      <Route path="/products/sizepicker" element={<SizePicker />} />
      <Route path="/products/questions" element={<ProductQuestions />} />
      <Route path="/products/measure" element={<Measure />} />
      <Route path="/products/singleproducts" element={<SingleProductsList />} />
      <Route
        path="/products/videoofproduct"
        element={<ProductRelatedVideo />}
      />
      <Route
        path="/products/productdimensions"
        element={<ProductDimensions />}
      />

      <Route path="/more/privacy-policy" element={<PrivacyPolicy />} />
      <Route
        path="/more/terms-and-conditions"
        element={<TermsAndConditions />}
      />

      {/* end */}
      {(username && username) !== "" || (user && user !== "") ? (
        <>
          <Route path="/adproduct" element={<AdProduct />} />
          <Route path="/admin-home" element={<AdminHome />} />
          <Route path="/view-types" element={<Types />} />
          <Route path="/adtype" element={<AdType />} />
          <Route path="/viewproducts" element={<ViewProducts />} />
          <Route path="/adpicture/:id" element={<AdPicture />} />
          <Route path="/advideo/:id" element={<AdVideo />} />
          <Route path="/viewdetails/:id" element={<ViewProduct />} />
          <Route path="/view-sizes" element={<Sizes />} />
          <Route path="/edit-size" element={<EditSize />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/view-order/:id" element={<OrderDetails />} />
          <Route path="/ad-type-video" element={<AdTypeVideo />} />
          <Route path="/view-size-guides" element={<ViewSizeGuides />} />
          <Route path="/edit-size-guide" element={<AdEditSizeGuide />} />
          <Route path="/add-size-guide-img" element={<AdSizeGuideImage />} />
          <Route path="/add-option-img" element={<AdOptionImage />} />
          <Route path="/view-size-finders" element={<ViewSizeFinders />} />
          <Route path="/view-steps" element={<ViewSteps />} />
          <Route path="/view-options" element={<ViewOptions />} />
          <Route path="/edit-step" element={<AdStep />} />
          <Route path="/edit-option" element={<AdOption />} />
          <Route path="/view-answers" element={<ViewAnswers />} />
          <Route path="/view-answer" element={<AnswerDetails />} />
          <Route path="/view-members" element={<ViewMembers />} />
          <Route path="/view-products-auth" element={<ViewProductsAuth />} />
          <Route path="/ad-product-image" element={<AdProductImage />} />
          <Route path="/view-dimensions/:id" element={<ViewDimensions />} />
          <Route path="/ad-shippings/:tid" element={<Shippings />} />
        </>
      ) : null}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
const mapStoreToProps = (state) => {
  return {
    username: state.user,
  };
};

export default connect(mapStoreToProps)(CreateRoutes);
